module.exports = __webpack_public_path__ + "img/lang-9.d9c9b587.jpg";